import React from "react";
import { withTheme } from "styled-components";

export const ClosePicturePreviewIcon = ({ theme, ...props }) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.0593 11.7645L22.1046 20.3366L13.6868 11.7645L11.8887 13.5013L20.337 22.1041L11.8887 30.7649L13.6254 32.563L22.1046 23.8717L30.2332 32.5325L32.0004 30.7649L23.8722 22.1041L31.8269 13.5321L30.0593 11.7645Z"
      fill="white"
    />
    <path
      d="M22 42.9375C33.5635 42.9375 42.9375 33.5635 42.9375 22C42.9375 10.4365 33.5635 1.0625 22 1.0625C10.4365 1.0625 1.0625 10.4365 1.0625 22C1.0625 33.5635 10.4365 42.9375 22 42.9375Z"
      stroke="white"
      strokeWidth="1.875"
    />
  </svg>
);

export default withTheme(ClosePicturePreviewIcon);
